// "Sự kiện" groups three pages as tabs; each keeps its own visibility rule.
export function isSchoolAccount(profile) {
  const roles = (profile && profile.roles) || []
  return ['super_admin', 'admin', 'group_chief', 'department_chief'].some((r) =>
    roles.includes(r)
  )
}

export function eventTabs(profile) {
  return [
    {
      name: 'Event',
      labelKey: 'MENU_EVENT',
      visible: isSchoolAccount(profile) && !!profile?.school?.contestFuture
    },
    { name: 'TRcvContest', labelKey: 'T_RCV_CONTEST_MENU', visible: true },
    { name: 'RTContest', labelKey: 'MENU_RT_CONTEST', visible: true }
  ].filter((t) => t.visible)
}

export const EVENT_TAB_MODULES = ['Event', 'TRcvContest', 'RTContest']
